module.exports = __webpack_public_path__ + "img/seccion1.4.1ed79a42.png";